import React, { useEffect, useState } from 'react'
import { Card, Form, Table } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { getCoberturas } from '../../../api/caso-general-client';
import { formato_monto } from '../../../common/Formatos';
import styles from './../../../styles.module.css';


const CoberturaPoliza = () => {
    const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
    const { llaves, antecedentesCasos, cfg_form } = data_datos_generales
    const [cobertura, setCobertura] = useState([]);
    const [exceso, setExceso] = useState([]);

    useEffect(() => {
        if (llaves && antecedentesCasos) {
            const coberturasVigentes = async () => {
                let query = Buffer.from(
                    JSON.stringify({
                        "idCaso": llaves.idCaso,
                        "idImplicado": llaves.idImplicado,
                        "tipoGestion": antecedentesCasos.antecedentesCasos[0].IdTipoGestion,
                        "tipoMovimiento": 261009,
                        "situacion": 999
                    })
                ).toString('base64')

                const response = await getCoberturas(query);
                setCobertura(response.coberturasPoliza)
                setExceso(response.rcExceso);
            }

            coberturasVigentes();
        }
    }, [llaves, antecedentesCasos])

    return (
        <div className={styles.container_tables}>
            <Card className='mt-1'>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: "#D9EDF6", color: "#8578CD" }}>
                    {cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-title'] : null}
                </Card.Header>

                <Table striped bordered hover>
                    <thead style={{ borderWidth: 'unset' }}>
                        <tr>
                            <th>{cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-lbl-cob'] : null}</th>
                            <th>{cfg_form ? `${cfg_form.cfg_form['gestcasosrecup-tab-coberturas-lbl-monto']}` : null}</th>
                            <th>{cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-lbl-fechaVig'] : null}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {cobertura && cobertura.map((pre, index) => {
                            return (
                                <tr key={index}>
                                    <td>{pre.cobertura}</td>
                                    <td>{formato_monto(pre.montoCobertura)}</td>
                                    <td>{pre.fechaVigenciaFmt}</td>
                                </tr>)
                            }) 
                        }
                    </tbody>
                </Table>
            </Card>

            <Card className='mt-2'>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: "#D9EDF6", color: "#8578CD" }}>
                    {cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-titlerce'] : null}
                </Card.Header>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>{cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-lbl-poliza'] : null}</th>
                            <th>{cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-lbl-siniestro'] : null}</th>
                            <th>{cfg_form ? cfg_form.cfg_form['gestcasosrecup-tab-coberturas-lbl-fecsini'] : null}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exceso && exceso.map((pre, index) => {
                            return (
                                <tr key={index}>
                                    <td>{pre.polizaRcExceso}</td>
                                    <td>{pre.siniestroRcExceso}</td>
                                    <td>{pre.fecSiniestroRcExcesoFormat}</td>
                                </tr>)
                            }) 
                        }
                    </tbody>
                </Table>
            </Card>
        </div>
    )
}

export default CoberturaPoliza;